import ProfileContainer from 'modules/profile';
import Header from './header';

const AccountPage = () => {
  return (
    <>
      <Header  />
      <ProfileContainer />
    </>
  );
};

export default AccountPage;
